import React from 'react';
// Components
import BrandDetailsComponent from 'components/common/BrandDetailsComponent/BrandDetailsComponent';

const BrandDetails = (): JSX.Element => {
  return <BrandDetailsComponent />;
};

export default BrandDetails;
